import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import {AbsUtilitiesModule} from '../abs-utilities/abs-utilities.module';

import { AbsMessagesComponent } from './abs-messages.component';

import {AbsDomHelperService} from '../abs-utilities/abs-dom-helper.service';
import {AbsKeymapService} from '../abs-utilities/abs-keymap.service';

@NgModule({
  imports: [
    CommonModule,
    AbsUtilitiesModule,
  ],
  declarations: [AbsMessagesComponent],
  exports: [AbsMessagesComponent, AbsUtilitiesModule],
  providers: [AbsDomHelperService,AbsKeymapService],
})
export class AbsMessagesModule { }
